/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import { CardBody, Col, Row } from 'react-bootstrap';
import { Input, Label } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useLazyGetRestaurantDetailsByIdQuery, useUpdaterestaurantBankDataMutation } from '../../../../redux/services/restaurantServices';
import EditButtonComponent from '../../../../components/EditButtonComponent';
import ButtonComponent from '../../../../components/ButtonComponent';
import { useSelector } from 'react-redux';

export interface RestaurantData {
    id: string;
    restaurantId: string;
    documentId: string;
    imageUrl: string;
    displayName: string;
    restaurantName: string;
    address: string;
    status: string;
    category: string;
    openingTime: string;
    closingTime: string;
    createdAt: {
      _seconds: number;
      _nanoseconds: number;
    };
    bankAccountDetails?: {
      accountName: string;
      accountNumber: string;
      bankName: string;
      branchName: string;
      swiftCode: string;
      createdAt: {
        _seconds: number;
        _nanoseconds: number;
      };
    };
  }
export interface RestaurantDataProps {
    restaurantData: RestaurantData | undefined;
}

const BankDetails: React.FC<RestaurantDataProps> = ({ restaurantData }) => {
    const navigate = useNavigate();

    const [editMode, setEditMode] = React.useState(true);
    const [isSaving, setIsSaving] = React.useState(false);

    const handleEdit = () => {
        setEditMode(!editMode);
    }

    const restaurantId =useSelector(
        (state: any) => state.restaurant.selectedRestaurantDetails.id
      );

    const [trigger, { data }] = useLazyGetRestaurantDetailsByIdQuery();

    useEffect(() => {
        if (restaurantId) {
            trigger(restaurantId);
        }
    }, [restaurantId, trigger]);

    const [bankDetails, setBankDetails] = React.useState({
        restaurantId: restaurantId || "",
        accountName: "",
        accountNumber: "",
        bankName: "",
        branchName: "",
        swiftCode: "",
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => {
        if (data) {
            setBankDetails({
                restaurantId: restaurantId || "",
                accountName: data?.restaurant.bankDetails?.accountName || "",
                accountNumber: data?.restaurant.bankDetails?.accountNumber || "",
                bankName: data?.restaurant.bankDetails?.bankName || "",
                branchName: data?.restaurant.bankDetails?.branchName || "",
                swiftCode: data?.restaurant.bankDetails?.swiftCode || "",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [data]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setBankDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const [updateBankDetails] = useUpdaterestaurantBankDataMutation();

    const handleSaveBankDetails = async () => {
        try {
            setIsSaving(true);
            const response = await updateBankDetails(bankDetails).unwrap();
            toast.success("Bank details updated successfully");
            setIsSaving(false);
        }
        catch (err) {
            toast.error("Failed to update bank details");
            setIsSaving(false);
        }
    }

    return (
        <>
            <CardBody>
                <div className="d-flex justify-content-end mb-3">
                    <EditButtonComponent onClick={handleEdit} />
                </div>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Account Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="accountName" value={bankDetails.accountName} onChange={handleInputChange} disabled={editMode} />
                    </Col>
                    <Col lg="2">
                        <Label>Account Number</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="accountNumber" value={bankDetails.accountNumber} onChange={handleInputChange} disabled={editMode} />
                    </Col>
                </Row>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Bank Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="bankName" value={bankDetails.bankName} onChange={handleInputChange} disabled={editMode} />
                    </Col>
                    <Col lg="2">
                        <Label>Branch Name</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="branchName" value={bankDetails.branchName} onChange={handleInputChange} disabled={editMode} />
                    </Col>
                </Row>
                <Row className='m-2 mt-0'>
                    <Col lg="2">
                        <Label>Swift Code</Label>
                    </Col>
                    <Col lg="4">
                        <Input name="swiftCode" value={bankDetails.swiftCode} onChange={handleInputChange} disabled={editMode} />
                    </Col>
                    <Col lg="6" className="mt-lg-0 mt-2">
                        {isSaving ? (
                            <ButtonComponent icon={<FontAwesomeIcon icon={faSpinner} spin />} titel='Saving...'  isDisabled={true} fullWidth/>
                        ) : (
                            <ButtonComponent titel='Save' onClick={handleSaveBankDetails} fullWidth isDisabled={editMode} />
                        )}
                    </Col>
                </Row>
            </CardBody>
        </>
    );
}

export default BankDetails;